import { useState } from 'react'
import { Card, Input, Button } from '../../components/ui'
import { CreditCard, TrendingUp, Users, Calendar, Search, Filter } from 'lucide-react'
import { supabase } from '../../lib/supabase'
import { useAuth } from '../../contexts/AuthContext'
import { useTenant } from '../../contexts/TenantContext'

export const PlatformSubscriptions = () => {
    const { user } = useAuth()
    const { activeTenant } = useTenant()

    return (
        <div className="p-8 max-w-7xl mx-auto bg-gray-50 min-h-screen">
            <div className="mb-8">
                <h1 className="text-3xl font-bold text-gray-900 mb-2 flex items-center gap-3">
                    <CreditCard className="text-purple-600" />
                    Abonnement Overzicht
                </h1>
                <p className="text-gray-500">Financiële analytics en abonnement statistieken</p>
            </div>

            {/* Date Filter */}
            <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 mb-8 flex items-center gap-4">
                <div className="flex items-center gap-2">
                    <span className="text-sm font-bold text-gray-700">Startdatum:</span>
                    <Input type="date" className="w-auto" />
                </div>
                <div className="flex items-center gap-2">
                    <span className="text-sm font-bold text-gray-700">Einddatum:</span>
                    <Input type="date" className="w-auto" />
                </div>
            </div>

            {/* KPI Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex justify-between items-center">
                    <div>
                        <p className="text-sm font-medium text-gray-500">Totale Omzet</p>
                        <h3 className="text-3xl font-bold text-gray-900">€0.00</h3>
                        <p className="text-xs text-gray-400 mt-1">Alle tijd</p>
                    </div>
                    <div className="bg-green-100 p-4 rounded-xl text-green-600 font-bold text-xl">
                        €
                    </div>
                </div>

                <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex justify-between items-center">
                    <div>
                        <p className="text-sm font-medium text-gray-500">Maandelijkse Omzet</p>
                        <h3 className="text-3xl font-bold text-gray-900">€0</h3>
                        <p className="text-xs text-gray-400 mt-1">Laatste 30 dagen</p>
                    </div>
                    <div className="bg-blue-100 p-4 rounded-xl text-blue-600">
                        <TrendingUp size={24} />
                    </div>
                </div>

                <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex justify-between items-center">
                    <div>
                        <p className="text-sm font-medium text-gray-500">Gem. Omzet per Gebruiker</p>
                        <h3 className="text-3xl font-bold text-gray-900">€0.00</h3>
                        <p className="text-xs text-gray-400 mt-1">Per maand</p>
                    </div>
                    <div className="bg-purple-100 p-4 rounded-xl text-purple-600">
                        <CreditCard size={24} />
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* Distribution */}
                <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 h-96">
                    <h3 className="font-bold text-gray-900 mb-4">Abonnement Verdeling</h3>
                    <div className="h-full flex items-center justify-center text-gray-400 bg-gray-50 rounded-lg">
                        Geen data beschikbaar
                    </div>
                </div>

                {/* Transactions */}
                <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                    <h3 className="font-bold text-gray-900 mb-4">Recente Transacties</h3>

                    <div className="flex gap-2 mb-4">
                        <Input placeholder="Zoek gebruiker..." className="bg-gray-50" />
                        <Button variant="outline"><Filter size={16} /> Status</Button>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-8 text-center text-gray-500">
                        Geen transacties gevonden voor de geselecteerde filters.
                    </div>
                </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 mt-8">
                <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <TrendingUp className="text-purple-600" /> Test Betalingen (Stripe Integration)
                </h3>
                <p className="text-gray-500 mb-4">
                    Test hier de Stripe API integratie. Dit maakt een checkout-sessie aan via de gekoppelde Stripe API keys.
                </p>
                <div className="flex gap-4">
                    <Button
                        onClick={async () => {
                            try {
                                const priceId = "price_1SfLZQKcWBh9Je2KwNGy0JJH" // Monthly Price ID from UpgradePage

                                const { data, error } = await supabase.functions.invoke('create-checkout', {
                                    body: {
                                        priceId: priceId,
                                        userId: user?.id,
                                        tenantId: activeTenant?.id,
                                        successUrl: window.location.href, // Stay here just refresh logic ideally or go to success
                                        cancelUrl: window.location.href
                                    }
                                })

                                if (error) throw error

                                if (data?.url) {
                                    window.location.href = data.url
                                } else {
                                    alert('Fout bij maken betaling: Geen URL ontvangen')
                                }
                            } catch (e) {
                                console.error(e)
                                alert('Fout: ' + e.message)
                            }
                        }}
                        className="bg-purple-600 hover:bg-purple-700 text-white"
                    >
                        Start Stripe Test Checkout
                    </Button>
                </div>
            </div>
        </div>
    )
}
